// extracted by mini-css-extract-plugin
module.exports = {"codesTree":"CodesTree_codesTree__38has","divisionTitle":"CodesTree_divisionTitle__KxILA"};